// test2960
(2960 && 0);
